import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/apiClient";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2, Clock } from "lucide-react";

export function PaymentSuccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | pending
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState("pending"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (e) { console.error("payment status poll failed", e); }
      if (tries >= 6) { setState("pending"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md border-slate-200 shadow-sm" data-testid="payment-success-page">
        <CardContent className="p-8 text-center">
          {state === "checking" && (
            <>
              <Loader2 className="h-14 w-14 text-[#1e7be0] mx-auto mb-4 animate-spin" />
              <h1 className="text-xl font-bold text-slate-800">Confirmando pagamento...</h1>
              <p className="text-sm text-slate-500 mt-1">Aguarde um instante.</p>
            </>
          )}
          {state === "paid" && (
            <>
              <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto mb-4" />
              <h1 className="text-xl font-bold text-slate-800">Pagamento confirmado!</h1>
              <p className="text-sm text-slate-500 mt-1">Obrigado. Sua OS foi marcada como paga.</p>
            </>
          )}
          {state === "pending" && (
            <>
              <Clock className="h-14 w-14 text-amber-500 mx-auto mb-4" />
              <h1 className="text-xl font-bold text-slate-800">Pagamento em processamento</h1>
              <p className="text-sm text-slate-500 mt-1">
                Se você pagou por boleto, a confirmação pode levar até 1 dia útil. Avisaremos você.
              </p>
            </>
          )}
          <Button className="mt-6 w-full bg-blue-600 hover:bg-blue-700" onClick={() => navigate("/app")}
            data-testid="back-to-app-button">Voltar para o app</Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <Card className="w-full max-w-md border-slate-200 shadow-sm" data-testid="payment-cancel-page">
        <CardContent className="p-8 text-center">
          <XCircle className="h-14 w-14 text-slate-400 mx-auto mb-4" />
          <h1 className="text-xl font-bold text-slate-800">Pagamento cancelado</h1>
          <p className="text-sm text-slate-500 mt-1">Nenhuma cobrança foi feita. Você pode tentar novamente quando quiser.</p>
          <Button className="mt-6 w-full bg-blue-600 hover:bg-blue-700" onClick={() => navigate("/app")}
            data-testid="back-to-app-button">Voltar para o app</Button>
        </CardContent>
      </Card>
    </div>
  );
}
